const MENU_ITEM_SELECTOR = '.menu-item-has-children';
const OPEN_CLASS = 'open';

// The block containing the menu
const BLOCK_SELECTOR = '.classic-menu-block';

// The class we add to the first parent with .wp-block-group
const GROUP_ACTIVE_CLASS = 'submenu-open';

document.addEventListener('DOMContentLoaded', () => {

    const burger = document.querySelector('.burger-menu');
    const nav = document.querySelector('.mega-menu-container');

    burger.addEventListener('click', function () {
        nav.classList.toggle('open');
        // Optionally toggle an active state for the burger itself:
        burger.classList.toggle('is-active');
    });

    const menuItems = document.querySelectorAll(MENU_ITEM_SELECTOR);

    const toggleGroupActiveClass = (blockContainer) => {
        const groupParent = blockContainer?.closest('.main-header-container');
        if (!groupParent) return;
        const hasOpenItem = !!blockContainer.querySelector(`${MENU_ITEM_SELECTOR}.${OPEN_CLASS}`);
        groupParent.classList.toggle(GROUP_ACTIVE_CLASS, hasOpenItem);
    };

    const toggleMenu = (menuItem, event) => {
        event.preventDefault();
        event.stopPropagation();

        menuItem.classList.toggle(OPEN_CLASS);

        const blockContainer = menuItem.closest(BLOCK_SELECTOR);
        toggleGroupActiveClass(blockContainer);
    };

    /**
     * Close all open menus and remove .active from each relevant .wp-block-group parent.
     */
    const closeAllMenus = () => {
        // Remove 'open' from all menu items
        menuItems.forEach(item => item.classList.remove(OPEN_CLASS));

        // For every .classic-menu-block, remove .active from its .wp-block-group parent
        document.querySelectorAll(BLOCK_SELECTOR).forEach(blockContainer => {
            const groupParent = blockContainer.closest('.wp-block-group');
            if (groupParent) {
                groupParent.classList.remove(GROUP_ACTIVE_CLASS);
            }
        });
    };

    /**
     * Returns a click handler to toggle the menu for a specific .menu-item-has-children.
     */
    const handleLinkClick = (menuItem) => (event) => {
        toggleMenu(menuItem, event);
    };

    /**
     * If user clicks outside any open menu, close all menus.
     */
    const handleDocumentClick = (event) => {
        // Check if the click happened inside an open menu item
        const clickedInsideOpenMenu = event.target.closest(`${MENU_ITEM_SELECTOR}.${OPEN_CLASS}`);
        if (!clickedInsideOpenMenu) {
            closeAllMenus();
        }
    };

    // Attach click handlers to each .menu-item-has-children
    menuItems.forEach(menuItem => {
        const link = menuItem.querySelector('a');
        if (link) {
            link.addEventListener('click', handleLinkClick(menuItem));
        }
    });

    // Listen for clicks outside any open menu
    document.addEventListener('click', handleDocumentClick);
    window.addEventListener('blur', () => {
        closeAllMenus();
    });
});
